import { cn } from '../lib';
import * as React from 'react';
import { useRTL } from '../hooks';
import * as SwitchPrimitives from '@radix-ui/react-switch';

const Switch: React.FC<React.ComponentProps<typeof SwitchPrimitives.Root>> = ({ className, ...props }) => {
  const isRTL = useRTL();

  return (
    <SwitchPrimitives.Root
      dir={isRTL ? 'rtl' : 'ltr'}
      className={cn(
        'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-chart-1 data-[state=unchecked]:bg-input',
        className,
      )}
      {...props}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          'pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=unchecked]:translate-x-0',
          isRTL ? 'data-[state=checked]:-translate-x-4' : 'data-[state=checked]:translate-x-4',
        )}
      />
    </SwitchPrimitives.Root>
  );
};
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
